import React from 'react'
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom'
import Home from 'components/templates/Home'
import Login from 'components/templates/sessions/Login'
import Signup from 'components/templates/sessions/Signup'
import NotFound from 'components/templates/NotFound'
import Dashboard from 'components/templates/Dashboard'
import Appointments from 'components/templates/Appointments'
import Accounts from 'components/templates/Accounts'
import Administrators from 'components/templates/Administrators'
import General from 'components/templates/General'
import Patients from 'components/templates/Patients'
import Widgets from 'components/templates/Widgets'
import Integrations from 'components/templates/Integrations'
import Setup from 'components/templates/Setup'
import Organization from 'components/templates/Organization';
import Operations from 'components/templates/Operations';
import Global from 'components/templates/Global';
import AppointmentTypes from 'components/templates/AppointmentTypes';
import Restrictions from 'components/templates/Restrictions';
import Booking from 'components/templates/Booking';
import Messages from 'components/templates/Messages';
import MessengerTemplates from 'components/templates/MessengerTemplates';
import WaitingRoom from 'components/templates/WaitingRoom';
import WaitListMembers from 'components/templates/WaitListMembers';
import WaitListMessages from 'components/templates/WaitListMessages';
import PrivateRoute, {ReadyRoute} from 'components/elements/PrivateRoute';
import Sexes from 'components/templates/Sexes';
import Breeds from 'components/templates/Breeds';
import Species from 'components/templates/Species';
import store from '../../../store'
import './index.less'

export default class App extends React.Component {
  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route exact path='/' render={()=>(
            <div>Practice key was not supplied! <br />Practice key MUST be supplied for application use.<br /> Example: medical.nextinline.io/your-key-here</div>
          )} />
          <PrivateRoute exact path='/:key' component={Dashboard} />
          <Route exact path='/:key/login' component={Login} />
          <Route exact path='/:key/signup' component={Signup} />

          <PrivateRoute exact path='/:key/setup' component={Setup} />
          <ReadyRoute exact path='/:key/admin' component={()=> <Redirect to={`/${store.getState().config.key}/admin/dashboard`} /> } />
          
          <ReadyRoute exact path='/:key/admin/dashboard' component={Dashboard} />
          <ReadyRoute exact path='/:key/admin/schedules' component={Dashboard} />
          
          <ReadyRoute exact path='/:key/admin/appointments/:type' component={Appointments} />
          {/* <ReadyRoute exact path='/:key/admin/appointments/:type' component={Appointments} /> */}

          <ReadyRoute exact path='/:key/admin/general' component={General} />
          <ReadyRoute exact path='/:key/admin/accounts' component={Accounts} />
          <ReadyRoute exact path='/:key/admin/accounts/:id' component={Accounts} />
          <ReadyRoute exact path='/:key/admin/accounts/:id/edit' component={Accounts} />
          <ReadyRoute exact path='/:key/admin/accounts/create' component={Accounts} />

          <ReadyRoute exact path='/:key/admin/patients' component={Patients} />
          <ReadyRoute exact path='/:key/admin/patients/:id' component={Patients} />
          <ReadyRoute exact path='/:key/admin/patients/:id/edit' component={Patients} />
          <ReadyRoute exact path='/:key/admin/patients/new' component={Patients} />

          <ReadyRoute exact path='/:key/admin/messages' component={Messages} />
          <ReadyRoute exact path='/:key/admin/messages/:id' component={Messages} />
          <ReadyRoute exact path='/:key/admin/messages/:id/new' component={Messages} />

          <ReadyRoute exact path='/:key/admin/inventory' component={Accounts} />
          <ReadyRoute exact path='/:key/admin/billing' component={Accounts} />
          
          <ReadyRoute exact path='/:key/admin/administrators' component={Administrators} />
          <ReadyRoute exact path='/:key/admin/administrators/:id' component={Administrators} />
          <ReadyRoute exact path='/:key/admin/administrators/:id/edit' component={Administrators} />
          <ReadyRoute exact path='/:key/admin/administrators/:id/edit-shifts' component={Administrators} />
          
          <ReadyRoute exact path='/:key/admin/messenger-templates' component={MessengerTemplates} />
          <ReadyRoute exact path='/:key/admin/messenger-templates/:messengerTemplateID' component={MessengerTemplates} />
          <ReadyRoute exact path='/:key/admin/messenger-templates/:messengerTemplateID/edit' component={MessengerTemplates} />
          <ReadyRoute exact path='/:key/admin/messenger-templates/:messengerTemplateID/new' component={MessengerTemplates} />
          
          <ReadyRoute exact path='/:key/admin/appointment-types' component={AppointmentTypes} />
          <ReadyRoute exact path='/:key/admin/appointment-types/:id' component={AppointmentTypes} />
          <ReadyRoute exact path='/:key/admin/appointment-types/:id/edit' component={AppointmentTypes} />
          <ReadyRoute exact path='/:key/admin/appointment-types/:id/edit-service-times' component={AppointmentTypes} />

          <ReadyRoute exact path='/:key/admin/sexes' component={Sexes} />
          <ReadyRoute exact path='/:key/admin/sexes/:id' component={Sexes} />
          <ReadyRoute exact path='/:key/admin/sexes/:id/edit' component={Sexes} />

          <ReadyRoute exact path='/:key/admin/breeds' component={Breeds} />
          <ReadyRoute exact path='/:key/admin/breeds/:id' component={Breeds} />
          <ReadyRoute exact path='/:key/admin/breeds/:id/edit' component={Breeds} />

          <ReadyRoute exact path='/:key/admin/species' component={Species} />
          <ReadyRoute exact path='/:key/admin/species/:id' component={Species} />
          <ReadyRoute exact path='/:key/admin/species/:id/edit' component={Species} />

          <ReadyRoute exact path='/:key/admin/restrictions' component={Restrictions} />
          
          <ReadyRoute exact path='/:key/admin/organization' component={Organization} />

          <ReadyRoute exact path='/:key/admin/organization-details' component={Dashboard} />
          <ReadyRoute exact path='/:key/admin/widgets' component={Widgets} />
          
          <ReadyRoute exact path='/:key/admin/integrations' component={Integrations} />
          
          <ReadyRoute exact path='/:key/admin/booking' component={Booking} />
          <ReadyRoute exact path='/:key/admin/operations' component={Operations} />
          <ReadyRoute exact path='/:key/admin/global' component={Global} />

          <ReadyRoute exact path='/:key/admin/waitingRoom' component={WaitingRoom} />

          <ReadyRoute exact path='/:key/admin/waitListMessages' component={WaitListMessages} />
          <ReadyRoute exact path='/:key/admin/waitListMembers' component={WaitListMembers} />
          <Route component={NotFound} />
        </Switch>
      </BrowserRouter>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/yields/Root/index.jsx